/**
 * Creates a debounced function that delays invoking the provided function until after
 * a specified delay has elapsed since the last time the debounced function was called.
 * timeoutId is used to make sure only 1 timeout is active at a time.
 * clearTimeout is called to reset the timer whenever the debounced function is called again before the delay has elapsed.
 * cancel method is added to the debounced function to allow cancellation of the pending function call.
 * Max delay of 1 second is set to prevent excessively long delays.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The number of milliseconds to delay.
 * @returns {Function} A new debounced function.
 */
export const debounce = (func, delay = 1000) => {
  let timeoutId;

  const debounced = (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };

  debounced.cancel = () => {
    clearTimeout(timeoutId);
  };

  return debounced;
};